// extracted by mini-css-extract-plugin
export default {"commonHeader":"style_commonHeader__DOz1g","starButton":"style_starButton__HbQJe","boxContainer":"style_boxContainer__Ah8RQ"};